import React, { useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../ui/Button';
import { RecoverableSession } from './utils/assessmentSessionRecovery';
import { useFocusTrap } from '../../hooks/useFocusTrap';
interface AssessmentRecoveryModalProps {
  session: RecoverableSession;
  onResume: () => void;
  onAbandon: () => void;
}
export function AssessmentRecoveryModal({
  session,
  onResume,
  onAbandon
}: AssessmentRecoveryModalProps) {
  const focusTrapRef = useFocusTrap(true);
  // Escape key to close (abandon)
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onAbandon();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onAbandon]);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" data-id="element-1314" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1315">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="recovery-title" className="bg-white rounded-3xl shadow-2xl max-w-lg w-full p-8" data-id="element-1316">
          <div className="text-center" data-id="element-1317">
            <div className="text-6xl mb-4" data-id="element-1318">📝</div>
            <h2 id="recovery-title" className="text-2xl font-black text-slate-900 mb-3 tracking-tight" data-id="element-1319">
              Toets hervatten?
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed font-medium" data-id="element-1320">
              Je hebt nog een toets openstaan! Je was bij vraag{' '}
              <strong data-id="element-1321">{session.attempt.answers.length + 1}</strong> van de{' '}
              <strong data-id="element-1322">{session.blueprint.questions.length}</strong>.
            </p>

            <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4 mb-6 text-left" data-id="element-1323">
              <div className="flex items-start gap-3" data-id="element-1324">
                <AlertCircle className="w-5 h-5 text-indigo-600 flex-shrink-0 mt-0.5" data-id="element-1325" />
                <div className="text-sm text-indigo-800 font-medium" data-id="element-1326">
                  <p data-id="element-1327">
                    Je voortgang is bewaard. Je kunt doorgaan waar je gebleven
                    was, of opnieuw beginnen.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-3" data-id="element-1328">
              <Button onClick={onResume} variant="primary" size="lg" fullWidth data-id="element-1329">
                Doorgaan met toets
              </Button>
              <Button onClick={onAbandon} variant="secondary" size="lg" fullWidth data-id="element-1330">
                Opnieuw beginnen
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>;
}